import { render, staticRenderFns } from "./ReqDeletionSigned.vue?vue&type=template&id=a4c34184&"
import script from "./ReqDeletionSigned.vue?vue&type=script&lang=js&"
export * from "./ReqDeletionSigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports